import React from 'react';
import { Tooltip } from '@mui/material';
import EditCloneDeleteMenu from "../../Menus/EditCloneDeleteMenu";



export const ContractSearchGridColumns = ({ hideActions, onEdit, onClone, onDelete }) => [
    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (params) => (
            <Tooltip title={`Click to see actions for record ${params.row.id}`}>
                <EditCloneDeleteMenu
                    onEdit={() => onEdit(params.row)}
                    onClone={() => onClone(params.row)}
                    onDelete={() => onDelete(params.row)}
                />
            </Tooltip>
        )
    },
    {    field: 'id',
        headerName: 'ID',

        sortable: true,
        width: 80,
    },
    {
        field: 'contractType',
        headerName: 'Type',
        description: '',
        sortable: true,
        // editable: true,
        hide: true,
        width: 120,
    },
    {
        field: 'createdOn',
        headerName: 'Created',
        description: '',
        sortable: false,
        width: 220,
    },
    {
        field: 'mcode',
        headerName: 'Code',
        description: '',
        sortable: false,
        editable: true,
        width: 150,
        hide: true
    },
    {
        field: 'name',
        headerName: 'Name',
        description: '',
        sortable: false,
        editable: true,
        width: 300,
    },


];
